<template>
  <div class="servicos">
    <section class="servicos-hero">
      <div class="container" data-aos="fade-up">
        <h1>Nossos Serviços</h1>
        <p>Soluções completas em engenharia para sua empresa</p>
      </div>
    </section>

    <section class="servicos-grid">
      <div class="container">
        <div class="servicos-container">
          <div class="servico-card" data-aos="fade-up" data-aos-delay="100">
            <div class="servico-icon">
              <i class="fas fa-file-alt"></i>
            </div>
            <h3>Laudo e ART</h3>
            <ul>
              <li>Brinquedos de Playgrounds</li>
              <li>Ar Condicionado e PMOC</li>
              <li>Sistemas de Exaustão para Cozinhas</li>
            </ul>
          </div>

          <div class="servico-card" data-aos="fade-up" data-aos-delay="200">
            <div class="servico-icon">
              <i class="fas fa-shield-alt"></i>
            </div>
            <h3>Segurança e Normas</h3>
            <ul>
              <li>Máquinas NR12</li>
              <li>NR11 Sistemas Transportadores</li>
              <li>Máquinas Pesadas</li>
            </ul>
          </div>

          <div class="servico-card" data-aos="fade-up" data-aos-delay="300">
            <div class="servico-icon">
              <i class="fas fa-tools"></i>
            </div>
            <h3>Responsabilidade Técnica</h3>
            <ul>
              <li>Engenheiro RT para Empresas</li>
              <li>Elevadores e Plataformas de Acessibilidade</li>
              <li>Andaimes</li>
            </ul>
          </div>

          <div class="servico-card" data-aos="fade-up" data-aos-delay="400">
            <div class="servico-icon">
              <i class="fas fa-fire"></i>
            </div>
            <h3>Exaustão e Bombeiros</h3>
            <ul>
              <li>Exaustão Industrial e Tabacarias</li>
              <li>AVCB e CLCB - Vistoria do Corpo de Bombeiros</li>
            </ul>
          </div>

          <div class="servico-card" data-aos="fade-up" data-aos-delay="500">
            <div class="servico-icon">
              <i class="fas fa-snowflake"></i>
            </div>
            <h3>Climatização</h3>
            <ul>
              <li>Manutenção e instalação de Ar Condicionado</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section class="cta-section">
      <div class="container" data-aos="fade-up">
        <h2>Precisa de um serviço específico?</h2>
        <p>Entre em contato conosco para um orçamento personalizado</p>
        <router-link to="/contato" class="cta-button">Solicitar Orçamento</router-link>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Servicos'
}
</script>

<style lang="scss" scoped>
.servicos {
  .servicos-hero {
    background: linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), #2c3e50;
    background-size: cover;
    background-position: center;
    height: 40vh;
    display: flex;
    align-items: center;
    text-align: center;
    color: white;

    .container {
      max-width: 800px;
      margin: 0 auto;
      padding: 0 1rem;

      h1 {
        font-size: 3rem;
        margin-bottom: 1rem;
      }

      p {
        font-size: 1.2rem;
      }
    }
  }

  .servicos-grid {
    padding: 5rem 0;
    background-color: var(--light-bg);

    .container {
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 1rem;
    }

    .servicos-container {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
      gap: 2rem;
    }

    .servico-card {
      background: white;
      border-radius: 10px;
      padding: 2rem;
      box-shadow: 0 4px 6px rgba(0,0,0,0.1);
      transition: transform 0.3s ease;

      &:hover {
        transform: translateY(-5px);
      }

      .servico-icon {
        width: 80px;
        height: 80px;
        background-color: var(--secondary-color);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto 1.5rem;

        i {
          font-size: 2rem;
          color: white;
        }
      }

      h3 {
        color: var(--primary-color);
        text-align: center;
        margin-bottom: 1.5rem;
        font-size: 1.5rem;
      }

      ul {
        list-style: none;
        padding: 0;

        li {
          margin-bottom: 0.8rem;
          padding-left: 1.5rem;
          position: relative;

          &:before {
            content: "•";
            color: var(--secondary-color);
            position: absolute;
            left: 0;
          }
        }
      }
    }
  }

  .cta-section {
    padding: 5rem 0;
    background-color: var(--primary-color);
    color: white;
    text-align: center;

    .container {
      max-width: 800px;
      margin: 0 auto;
      padding: 0 1rem;
    }

    h2 {
      margin-bottom: 1rem;
    }

    p {
      margin-bottom: 2rem;
    }
  }

  .cta-button {
    display: inline-block;
    padding: 1rem 2rem;
    background-color: var(--secondary-color);
    color: white;
    text-decoration: none;
    border-radius: 5px;
    transition: background-color 0.3s ease;

    &:hover {
      filter: brightness(90%);
    }
  }
}

@media (max-width: 768px) {
  .servicos {
    .servicos-hero {
      .container {
        h1 {
          font-size: 2.5rem;
        }
      }
    }
  }
}
</style> 